import { defineComponent as _defineComponent } from 'vue'
import {
  ButtonContainer,
  ButtonPrimary,
  HelperViewStatus,
  Modal
} from '@warrenbrasil/nebraska-web';
import { Portal } from '@/modules/common/components/Portal';
import { IErrorModalContent } from '@/modules/onboarding/signup/types';
import { PropType } from 'vue';
import { useRouter } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorModal',
  props: {
  isOpen: { type: Boolean, default: false },
  content: {
    type: Object as PropType<IErrorModalContent>,
    default: () => ({ title: '', description: '' })
  }
},
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props;



const router = useRouter();

return { __sfc: true,emit, props, router, ButtonContainer, ButtonPrimary, HelperViewStatus, Modal, Portal }
}

})